module.exports = __webpack_public_path__ + "static/media/bbms-logo.05e3b5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/static/img/bbms-logo.png
// module id = 1293
// module chunks = 0